import { render, staticRenderFns } from "./DeviceApkUpgrade.vue?vue&type=template&id=dba89c2c&scoped=true"
import script from "./DeviceApkUpgrade.vue?vue&type=script&lang=js"
export * from "./DeviceApkUpgrade.vue?vue&type=script&lang=js"
import style0 from "./DeviceApkUpgrade.vue?vue&type=style&index=0&id=dba89c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba89c2c",
  null
  
)

export default component.exports